import useAccessTokenStore from 'auth/lib/useAccessTokenStore';

export const getApolloClient = () => useAccessTokenStore.getState().client;
